import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var MetroLogoCompact = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { fill: "#FFED00", fillRule: "evenodd", d: "M23.3 32L30 11.9V32h10V0H26.5L20 16 13.5 0H0v32h10.001V11.9L16.75 32z" })), '0 0 40 32', 'MetroLogoCompact');
//# sourceMappingURL=MetroLogoCompact.js.map